import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-ewaste',
  templateUrl: './invoice-ewaste.component.html',
  styleUrls: ['./invoice-ewaste.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceEwasteComponent extends InvoiceComponent implements OnInit {
  @Input() 
  invoice: InvoiceInterface;
  
  public defaultInvoice = {
    type: "ewaste",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    pdf: {
      file: "invoice-ewaste"
    },
    lineItems: [
      {
        item: 'E-Waste Collection',
        desc: '',
        qty: 1,
        price: 3500
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: [],
    additionalData: {
      contact: "test",
      contactNumber: "",
      collectionAddress: "",
      quantity: "",
      dataDestruction: "",
      collectionHours: "",
      notes: ""
    }
  }

  displayedColumns: string[] = ['item', 'desc', 'price', 'actions'];

}
